(function () {
  var PREVIEW_DURATION = 5;

  function initUGCCarousel(sectionEl) {
    var section = sectionEl || document.querySelector('.oddit-section-ugc');
    if (!section) return;

    var track = section.querySelector('.oddit-section-ugc__carousel-track');
    var cards = section.querySelectorAll('.oddit-section-ugc__card');
    var prevBtn = section.querySelector('.oddit-section-ugc__arrow--prev');
    var nextBtn = section.querySelector('.oddit-section-ugc__arrow--next');
    var dots = section.querySelectorAll('.oddit-section-ugc__dot');

    if (!track || cards.length === 0) return;

    var currentIndex = 0;
    var videoCards = [];
    var sectionVisible = false;
    var videosLoaded = false;

    /* ---- Set up each video card ---- */
    cards.forEach(function (card) {
      var video = card.querySelector('.oddit-section-ugc__video');
      if (!video) return;

      var playPauseBtn = card.querySelector('.oddit-section-ugc__play-pause-btn');
      var muteBtn = card.querySelector('.oddit-section-ugc__mute-btn');
      var thumbnail = card.querySelector('.oddit-section-ugc__thumbnail');

      var state = {
        card: card,
        video: video,
        playPauseBtn: playPauseBtn,
        muteBtn: muteBtn,
        thumbnail: thumbnail,
        isFullPlay: false,       /* true when user clicks play */
        previewActive: false
      };

      videoCards.push(state);

      /* Preview loop: loop 0–5s, hide thumbnail so video shows */
      function startPreview() {
        if (state.isFullPlay) return;
        state.previewActive = true;
        video.currentTime = 0;
        video.muted = true;
        video.play().catch(function () {});
        if (thumbnail) thumbnail.style.opacity = '0';
      }

      function stopPreview() {
        if (state.isFullPlay) return;
        state.previewActive = false;
        video.pause();
        video.currentTime = 0;
        if (thumbnail) thumbnail.style.opacity = '';
      }

      /* Enforce 5s loop for preview */
      video.addEventListener('timeupdate', function () {
        if (!state.isFullPlay && state.previewActive && video.currentTime >= PREVIEW_DURATION) {
          video.currentTime = 0;
        }
      });

      /* Play/pause button */
      if (playPauseBtn) {
        playPauseBtn.addEventListener('click', function () {
          if (state.isFullPlay) {
            /* Pause → go back to preview */
            state.isFullPlay = false;
            video.pause();
            video.currentTime = 0;
            video.muted = true;
            setPlayIcon(state);
            /* Reset mute button to muted state */
            if (muteBtn) {
              muteBtn.setAttribute('data-muted', 'true');
              muteBtn.setAttribute('aria-label', 'Unmute video');
              muteBtn.querySelector('.oddit-section-ugc__icon-muted').style.display = '';
              muteBtn.querySelector('.oddit-section-ugc__icon-unmuted').style.display = 'none';
            }
            /* Restart all previews */
            startAllPreviews();
          } else {
            /* Play full video — stop all other videos first */
            stopAllVideos();
            state.isFullPlay = true;
            state.previewActive = false;
            video.currentTime = 0;
            video.muted = false;
            video.play().catch(function () {});
            if (thumbnail) thumbnail.style.opacity = '0';
            setPauseIcon(state);
            /* Show unmuted icon */
            if (muteBtn) {
              muteBtn.setAttribute('data-muted', 'false');
              muteBtn.setAttribute('aria-label', 'Mute video');
              muteBtn.querySelector('.oddit-section-ugc__icon-muted').style.display = 'none';
              muteBtn.querySelector('.oddit-section-ugc__icon-unmuted').style.display = '';
            }
          }
        });
      }

      /* Mute button */
      if (muteBtn) {
        muteBtn.addEventListener('click', function () {
          video.muted = !video.muted;
          muteBtn.setAttribute('data-muted', video.muted ? 'true' : 'false');
          muteBtn.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
          muteBtn.querySelector('.oddit-section-ugc__icon-muted').style.display = video.muted ? '' : 'none';
          muteBtn.querySelector('.oddit-section-ugc__icon-unmuted').style.display = video.muted ? 'none' : '';
        });
      }
    });

    function setPlayIcon(state) {
      if (!state.playPauseBtn) return;
      state.playPauseBtn.setAttribute('data-playing', 'false');
      state.playPauseBtn.setAttribute('aria-label', 'Play video');
      state.playPauseBtn.querySelector('.oddit-section-ugc__icon-play').style.display = '';
      state.playPauseBtn.querySelector('.oddit-section-ugc__icon-pause').style.display = 'none';
    }

    function setPauseIcon(state) {
      if (!state.playPauseBtn) return;
      state.playPauseBtn.setAttribute('data-playing', 'true');
      state.playPauseBtn.setAttribute('aria-label', 'Pause video');
      state.playPauseBtn.querySelector('.oddit-section-ugc__icon-play').style.display = 'none';
      state.playPauseBtn.querySelector('.oddit-section-ugc__icon-pause').style.display = '';
    }

    /* Stop all videos (previews and full play) */
    function stopAllVideos() {
      videoCards.forEach(function (s) {
        s.isFullPlay = false;
        s.previewActive = false;
        s.video.pause();
        s.video.currentTime = 0;
        s.video.muted = true;
        setPlayIcon(s);
        /* Reset mute button */
        if (s.muteBtn) {
          s.muteBtn.setAttribute('data-muted', 'true');
          s.muteBtn.setAttribute('aria-label', 'Unmute video');
          var mutedIcon = s.muteBtn.querySelector('.oddit-section-ugc__icon-muted');
          var unmutedIcon = s.muteBtn.querySelector('.oddit-section-ugc__icon-unmuted');
          if (mutedIcon) mutedIcon.style.display = '';
          if (unmutedIcon) unmutedIcon.style.display = 'none';
        }
      });
    }

    /* Restart all preview loops (only if section is visible) */
    function startAllPreviews() {
      if (!sectionVisible) return;
      videoCards.forEach(function (s) {
        if (!s.isFullPlay) {
          s.previewActive = true;
          s.video.currentTime = 0;
          s.video.muted = true;
          s.video.play().catch(function () {});
          if (s.thumbnail) s.thumbnail.style.opacity = '0';
        }
      });
    }

    /* Stop all preview loops (without resetting full-play state) */
    function pauseAllPreviews() {
      videoCards.forEach(function (s) {
        if (!s.isFullPlay && s.previewActive) {
          s.previewActive = false;
          s.video.pause();
        }
      });
    }

    /* ---- IntersectionObserver: load & play videos only when section is in view ---- */
    function loadAndStartVideos() {
      if (videosLoaded) {
        startAllPreviews();
        return;
      }
      videosLoaded = true;
      videoCards.forEach(function (s) {
        s.video.preload = 'auto';
        s.video.load();
      });
      startAllPreviews();
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            sectionVisible = true;
            loadAndStartVideos();
          } else {
            sectionVisible = false;
            pauseAllPreviews();
          }
        });
      }, { rootMargin: '200px 0px' });
      observer.observe(section);
    } else {
      /* Fallback: load immediately */
      loadAndStartVideos();
    }

    /* ---- Carousel navigation ---- */
    function getVisibleCount() {
      var wrapperWidth = track.parentElement.offsetWidth;
      var cardWidth = cards[0].offsetWidth;
      var gap = parseFloat(getComputedStyle(track).gap) || 0;
      return Math.max(1, Math.floor((wrapperWidth + gap) / (cardWidth + gap)));
    }

    function getMaxIndex() {
      var visibleCount = getVisibleCount();
      return Math.max(0, cards.length - visibleCount);
    }

    function isMobileUgcCarousel() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    function updateCarousel() {
      var gap = parseFloat(getComputedStyle(track).gap) || 0;
      var cardWidth = cards[0].offsetWidth;
      var stride = cardWidth + gap;
      var wrapper = track.parentElement;
      var wrapperStyles = getComputedStyle(wrapper);

      if (isMobileUgcCarousel()) {
        /* Track sits in the content box; center the active card in the full inner width (padding box). */
        var pl = parseFloat(wrapperStyles.paddingLeft) || 0;
        var pr = parseFloat(wrapperStyles.paddingRight) || 0;
        var vw = wrapper.clientWidth;
        var contentW = vw - pl - pr;
        var trackWidth = track.scrollWidth;
        /* Positive translateX moves the track right (CSS), centering the slide under vw/2. */
        var idealTx = vw / 2 - pl - currentIndex * stride - cardWidth / 2;
        var minTx = Math.min(0, contentW - trackWidth);
        var tx = Math.max(minTx, idealTx);
        track.style.transform = 'translateX(' + tx + 'px)';
      } else {
        var offset = currentIndex * stride;
        track.style.transform = 'translateX(-' + offset + 'px)';
      }

      updateDots();
    }

    function updateDots() {
      var maxIndex = getMaxIndex();
      var totalDots = dots.length;
      if (totalDots === 0) return;

      var activeDot = 0;
      if (maxIndex > 0) {
        activeDot = Math.round((currentIndex / maxIndex) * (totalDots - 1));
      }

      dots.forEach(function (dot, i) {
        var isActive = i === activeDot;
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    function goNext() {
      var maxIndex = getMaxIndex();
      if (currentIndex < maxIndex) {
        currentIndex++;
      } else {
        currentIndex = 0;
      }
      updateCarousel();
    }

    function goPrev() {
      var maxIndex = getMaxIndex();
      if (currentIndex > 0) {
        currentIndex--;
      } else {
        currentIndex = maxIndex;
      }
      updateCarousel();
    }

    function onNextClick() { goNext(); }
    function onPrevClick() { goPrev(); }

    if (nextBtn) nextBtn.addEventListener('click', onNextClick);
    if (prevBtn) prevBtn.addEventListener('click', onPrevClick);

    var dotClickHandlers = [];
    dots.forEach(function (dot, i) {
      var handler = function () {
        var maxIndex = getMaxIndex();
        var totalDots = dots.length;
        if (totalDots <= 1) {
          currentIndex = 0;
        } else {
          currentIndex = Math.round((i / (totalDots - 1)) * maxIndex);
        }
        updateCarousel();
      };
      dotClickHandlers.push(handler);
      dot.addEventListener('click', handler);
    });

    var resizeTimeout;
    function onResize() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function () {
        var maxIndex = getMaxIndex();
        if (currentIndex > maxIndex) {
          currentIndex = maxIndex;
        }
        updateCarousel();
      }, 150);
    }
    window.addEventListener('resize', onResize);

    var startX = 0;
    var isDragging = false;

    function onTouchStart(e) {
      startX = e.touches[0].clientX;
      isDragging = true;
    }

    function onTouchEnd(e) {
      if (!isDragging) return;
      isDragging = false;
      var endX = e.changedTouches[0].clientX;
      var diff = startX - endX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) {
          goNext();
        } else {
          goPrev();
        }
      }
    }

    track.addEventListener('touchstart', onTouchStart, { passive: true });
    track.addEventListener('touchend', onTouchEnd, { passive: true });

    updateCarousel();
    if (typeof requestAnimationFrame === 'function') {
      requestAnimationFrame(function () {
        updateCarousel();
      });
    }

    return function cleanup() {
      stopAllVideos();
      if (nextBtn) nextBtn.removeEventListener('click', onNextClick);
      if (prevBtn) prevBtn.removeEventListener('click', onPrevClick);
      dots.forEach(function (dot, i) {
        dot.removeEventListener('click', dotClickHandlers[i]);
      });
      window.removeEventListener('resize', onResize);
      track.removeEventListener('touchstart', onTouchStart);
      track.removeEventListener('touchend', onTouchEnd);
      clearTimeout(resizeTimeout);
    };
  }

  var cleanupMap = {};

  document.querySelectorAll('.oddit-section-ugc').forEach(function (el) {
    var id = el.id;
    if (id) {
      cleanupMap[id] = initUGCCarousel(el);
    } else {
      initUGCCarousel(el);
    }
  });

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.oddit-section-ugc');
    if (section) {
      var id = section.id;
      if (id) {
        cleanupMap[id] = initUGCCarousel(section);
      } else {
        initUGCCarousel(section);
      }
    }
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector('.oddit-section-ugc');
    if (section && section.id && cleanupMap[section.id]) {
      cleanupMap[section.id]();
      delete cleanupMap[section.id];
    }
  });
})();
